
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/short",
      function () {
        return require("private-next-pages/short.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/short"])
      });
    }
  